import { useQuery } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import { Notes } from '@/reports/sections/NotesSection/Notes/Notes';

export function useAccountNotes(reportPermaLink?: string) {
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: ['accountNotes'],
    queryFn: Notes.getAccountNotes,
    onError: (error) => {
      logError('Error fetching notes', error as Error);
    },
  });

  const { data } = result;
  const reportNotesCount = () => {
    if (!reportPermaLink) return null;
    return (
      data?.filter(
        (report: { permalink: string }) => report.permalink === reportPermaLink
      )[0]?.notes?.length || null
    );
  };

  return { ...result, reportNotesCount };
}
